import axiosClient from "../axiosClient";
import streamingClient from "../streamingClient";
import { format, formatDB } from "../../utils";
import axiosClient_v2 from "../axiosClient_v2";
export const aiConfigService = {
  get: (params) => {
    return axiosClient.get(
      `/aiConfig/get-list-ai-config/?camera_code=${params.cameraCode}&ai_service_code=${params.codeService}`
    );
  },
  update: (params) => {
    return axiosClient.post("/aiConfig/post-add-ai-config/", params);
  },
  remove: (cameraCode, aiServiceCode) => {
    return axiosClient.delete(
      `/aiConfig/delete-remove-ai-config/?camera_code=${cameraCode}&ai_service_code=${aiServiceCode}`
    );
  },
  getDefaultConfig: (data) => {
    return streamingClient.get(
      `/eventManagement/get-config-cleaning-event/?camera_id=${data}`
    );
  },
  configAi: (data) => {
    return streamingClient.post(
      "/eventManagement/post-update-config-cleaning-event/",
      data
    );
  },
  postListValueParam: (data) => {
    return axiosClient.post('/aiServiceParam/post-list-value-param/', {
      list_param: {
        data: data
      }
    })
  },
  putChangeIsVoice: (cameraCode, data) => {
    // console.log(cameraCode);
    return axiosClient.put(`/aiConfig/put-change-is-voice-camera/?camera_code=${cameraCode}`, data)
  }
};

export const getListServices = {
  get: (param) => {
    return axiosClient.get("/service/get-list-services/", {
      params: param,
    });
  },
  checkServiceCamera: (
    listCode = [],
    timeStart,
    timeEnd,
    hourStart,
    hourEnd,
    aiCode
  ) => {
    const hour_end = hourEnd ? { hour_end: hourEnd + ":00" } : {};
    const hour_start = hourStart ? { hour_start: hourStart + ":00" } : {};
    const ai_service_code = aiCode === "All" ? {} : { ai_service_code: aiCode };
    return axiosClient_v2.post("/camAI/post-check-camera-has-event/", {
      ...ai_service_code,

      date: format(timeEnd),
      ...hour_end,
      ...hour_start,
      list_camera_code: listCode,
    });
  },
};

export const getCommonObject = {
  getList: () => {
    return axiosClient.get("/commonObjectServices/get-list-common-object/");
  },
  getOfCamera: (param) => {
    return axiosClient.get(
      "commonObjectServices/get-list-common-object-by-camera/",
      {
        params: param,
      }
    );
  },
  postConfig: (data) => {
    return axiosClient.post(
      "/commonObjectServices/post-common-object-to-camera/",
      data
    );
  },
  getOfCameraAPLR: (param) => {
    return axiosClient.get(
      "/commonObjectServices/get-list-alpr-object-by-camera/",
      {
        params: param,
      }
    );
  },
  postConfigALPR: (data) => {
    return axiosClient.post(
      "/commonObjectServices/post-alpr-object-to-camera/",
      data
    );
  },
};
